import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-section">
          <div className="connect-left">
            <h2>
              <Link to="Contact">
                Let’s Connect
              </Link>
            </h2>
            <p>
              Reach out to us for any questions or support.
            </p>
          </div>          <h2 className="footer-logo">ZETNTECH</h2>
          <p>
            We transform ideas into digital solutions using
            cutting-edge technology and innovation.
          </p>
        </div>

        {/* CENTER */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/WhoWeAre">Who We Are</Link></li>
            <li><Link to="/career">Careers</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/insights/blogs">Blogs</Link></li>
          </ul>
        </div>

        {/* RIGHT */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p>Email: info@zetntech.com</p>
          <p>Phone: +91 8178181066</p>
          <p>Phone: +91 8527203697</p>
          <p>Location: India</p>

          <div className="social-icons">
            <a href="https://www.linkedin.com/company/zetntech/" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
            </a>
            <a href="https://x.com/zetntech" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faTwitter} /> Twitter
            </a>
            <a href="https://www.instagram.com/zetntech" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} /> Instagram
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} ZETNTECH. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
